import pinia from '@/common/pinia'
import { useChangelogStore } from '@/stores/changelog'

/**
 * User dropdown menu configuration.
 * Each item can have a `show` function that receives the store to determine visibility.
 * Items with `onClick` render as action buttons instead of links; `unreadDot`
 * shows the changelog unread dot.
 *
 * Role hierarchy:
 * - system (any system_role): Gets admin links
 * - adminPrivileges (owner/admin): Full access to organization settings
 * - editor (member): Limited settings access
 * - viewer: No menu items, only Log Out
 */
export default [
  {
    label: 'Admin panel',
    href: '/admin/organizations',
    icon: 'fa-solid fa-users-gear',
    show: (store) => store.trueUserAppAdmin,
    dividerAfter: true
  },
  {
    label: 'My profile',
    href: '/profile/account',
    icon: 'fa-regular fa-user',
    show: (store) => !store.organization.isLinda
  },
  {
    label: 'Organization',
    href: '/users',
    icon: 'fa-solid fa-building',
    show: (store) => store.user.adminPrivileges && !store.organization.sso
  },
  {
    label: 'Google Accounts',
    href: '/google_accounts',
    icon: 'fa-brands fa-google',
    show: (store) => store.user.editor
  },
  {
    label: 'Facebook Accounts',
    href: '/facebook_accounts',
    icon: 'fa-brands fa-facebook',
    show: (store) => store.user.editor && store.hasFeature('fb')
  },
  {
    label: 'Billing',
    href: '/billing/edit',
    icon: 'fa-solid fa-credit-card',
    show: (store) => store.user.owner && !store.organization.sso
  },
  {
    label: 'EXIF Templates',
    href: '/exif_templates',
    icon: 'fa-solid fa-image',
    show: (store) => store.user.editor && !store.organization.sso
  },
  {
    label: 'Help',
    href: (store) => store.wlc.helpCenterUrl,
    icon: 'fa-solid fa-circle-question',
    show: (store) => store.user.editor && !store.organization.sso,
    external: true
  },
  {
    label: 'Changelog',
    icon: 'fa-solid fa-bullhorn',
    onClick: () => useChangelogStore(pinia).open(),
    unreadDot: true
  },
  {
    label: 'Log Out',
    href: '/sign_out',
    icon: 'fa-solid fa-right-from-bracket',
    method: 'delete',
    show: (store) => !store.organization.sso,
    dividerBefore: true
  }
]
